import type { TranslationKeys } from './en'

export const de: TranslationKeys = {
  schoolSubtitle: 'Zugriff über die Agenda1-App',
  scanQrCode: 'Richten Sie Ihre Handykamera auf den QR-Code',
  or: 'oder',
  downloadApp: 'Laden Sie die App aus den offiziellen Stores herunter',
  appStoreBadgeUrl: 'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/de-de?size=250x83',
  appStoreBadgeAlt: 'Laden im App Store',
  playStoreBadgeUrl: 'https://play.google.com/intl/de_de/badges/static/images/badges/de_badge_web_generic.png',
  playStoreBadgeAlt: 'Jetzt bei Google Play',
  openAppStore: 'Im App Store öffnen',
  openPlayStore: 'Bei Google Play öffnen',
  printQrCode: 'QR-Code drucken',
  schoolCode: 'Schulcode',
  scanInstruction: 'Richten Sie Ihre Handykamera auf den QR-Code oben',
  accessUrl: 'oder besuchen Sie',
  needHelp: 'Brauchen Sie Hilfe? Kontaktieren Sie den Support',
  support: 'support@agenda1.app',
  copyright: `© ${new Date().getFullYear()} Agenda1. Alle Rechte vorbehalten.`,
  // Mobile 2-step flow
  step1Title: 'App herunterladen',
  step1Description: 'Falls noch nicht vorhanden, laden Sie Agenda1 herunter',
  step2Title: 'Schule öffnen',
  step2Description: 'Tippen Sie, um die Schule in der App zu öffnen',
  openSchoolButton: 'Schule in App öffnen',
  alreadyHaveApp: 'Haben Sie die App bereits?'
}
